import React, { useEffect, useState } from 'react';
import './PhotoHistory.scss';
import { usePortContext } from '../service/MessageChannelContext';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navbar } from '../components/micro/NavBar/NavBar';
import PhotoDiaryLogo from '../images/photo-diary-logo.png';
import PhotoDeleteIcon from '../images/photo-delete-icon.png';
import { SelfieCarousel } from '../components/micro/SelfieCarousel/SelfieCarousel';
import { ScoreCard } from '../components/micro/ScoreCard/ScoreCard';
import { ViewToggle } from '../components/micro/ViewToggle/ViewToggle';
import { ReportPhotoList } from '../components/micro/ReportPhotoList/ReportPhotoList';

const PhotoHistory = () => {
  const {
    events: { emitDeleteAnalysisEvent },
    historyData,
  } = usePortContext();

  const { state } = useLocation();

  const [selectedPhoto, setSelectedPhoto] = useState();

  const [reportHistory, setReportHistory] = useState();

  const [selectedView, setSelectedView] = useState('photo');
  const [isDetail, setIsDetail] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (historyData?.analyses) {
      setReportHistory(historyData.analyses);
      setSelectedPhoto(
        state?.analysisId ? historyData.analyses.find((report) => report.analysisId === state?.analysisId) : historyData.analyses[0],
      );
    }
  }, [historyData]);

  useEffect(() => {
    if (selectedView === 'album' && !historyData?.analyses?.length) {
      navigate('/mySkinDiary');
    }
  }, [selectedView]);

  return (
    <div className="photo-history">
      {selectedView === 'photo' && (
        <>
          <Navbar
            logo={moment(selectedPhoto?.createdAt).format('D MMM YYYY h:mm')}
            isText
            rightButtonIcon={PhotoDeleteIcon}
            rightButtonAction={() => {
              const index = reportHistory.findIndex((report) => report.analysisId === selectedPhoto?.analysisId);
              emitDeleteAnalysisEvent(selectedPhoto?.analysisId);
              if (reportHistory.length === 1) {
                navigate('/mySkinDiary');
                return;
              }
              navigate('/photoHistory', {
                state: { analysisId: (reportHistory[index + 1] || reportHistory[index - 1]).analysisId },
                replace: true,
              });
            }}
            pinned
            leftButtonAction={
              isDetail
                ? () => {
                    setIsDetail(false);
                    setSelectedView('album');
                  }
                : () => navigate(-1)
            }
          />
          <div className={`photo-container ${isDetail ? 'full-container' : ''}`}>
            <img src={selectedPhoto?.imageUrls?.skinHealth} alt="SkinHealth" className="selfie-photo" />
            <ScoreCard scores={selectedPhoto?.scores || {}} onClick={() => navigate('/skinReport', { state: selectedPhoto })} />
          </div>
          {!isDetail && (
            <>
              <SelfieCarousel
                reports={reportHistory}
                onClick={(analysisId) => setSelectedPhoto(reportHistory.find((report) => report.analysisId === analysisId))}
                selectedAnalysisId={selectedPhoto?.analysisId}
              />
              <ViewToggle view={selectedView} setView={setSelectedView} />
            </>
          )}
        </>
      )}
      {selectedView === 'album' && (
        <>
          <Navbar logo={PhotoDiaryLogo} rightButtonIcon={null} />
          <ReportPhotoList
            reports={reportHistory}
            onClick={(analysisId) => {
              setSelectedPhoto(reportHistory.find((report) => report.analysisId === analysisId));
              setSelectedView('photo');
              setIsDetail(true);
            }}
            addBottomMargin
          />
          <ViewToggle view={selectedView} setView={setSelectedView} />
        </>
      )}
    </div>
  );
};

export default PhotoHistory;
